var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9884 77.1849C63.9884 77.1849 64.3798 72.7292 64.5754 70.4663L56.4302 71.3051L57.1333 83.6986H72.2384C72.2384 83.6986 73.4875 80.6811 71.7241 78.2133C69.4495 75.0302 63.9884 77.1849 63.9884 77.1849Z",
    fill: "#344DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7088 78.1595C46.7088 78.1595 47.0268 74.5427 47.2223 72.2798H39.1504L39.8536 84.6733H54.9586C54.9586 84.6733 56.2077 81.6557 54.4444 79.188C52.1698 76.0048 46.7088 78.1595 46.7088 78.1595Z",
    fill: "#A0DDFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9884 77.1849C63.9884 77.1849 64.3798 72.7292 64.5754 70.4663L56.4302 71.3051L57.1333 83.6986H72.2384C72.2384 83.6986 73.4875 80.6811 71.7241 78.2133C69.4495 75.0302 63.9884 77.1849 63.9884 77.1849Z",
    fill: "#A0DDFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2953 73.3816C64.2953 73.3816 64.3224 73.0964 64.5189 70.8213H56.4033L56.5899 74.1102L64.2953 73.3816Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9999 74.8263C46.9999 74.8263 47.0268 74.5427 47.2223 72.2798H39.1504L39.336 75.551L46.9999 74.8263Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 28.0877L30.4339 38.853L81.8754 35.1052L60.6012 23.8091L15.125 28.0877Z",
    fill: "#FEB7FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4341 38.8529V74.2259L79.0708 70.9243V35.5547L30.4341 38.8529Z",
    fill: "#FFDF51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6587 29.7124L18.2336 65.4429L30.4339 74.2259V38.853L16.6587 29.7124Z",
    fill: "#B431FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6533 47.2543L30.4341 38.8528L81.8756 35.105V44.582L29.6533 47.2543Z",
    fill: "#FF61D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 28.0879L30.4339 38.8532L29.6531 47.2547L15.125 35.5549V28.0879Z",
    fill: "#FF61D4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6288 32.808L34.0853 11.3271L15.6157 24.3763L45.6288 32.808Z",
    fill: "#344DF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2324 32.808L56.7759 11.3271L75.2455 24.3763L45.2324 32.808Z",
    fill: "#344DF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8984 32.7285L66.205 36.2469L68.8195 48.9197L63.5791 45.773L60.119 49.9727L58.6279 37.2834L48.1099 32.9018",
    fill: "#344DF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4491 32.4482L22.375 33.1859L19.9619 45.7751L23.72 43.0089L26.8543 47.8391L28.1177 37.2242L44.3992 32.4482",
    fill: "#344DF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8395 33.2213C50.8395 30.3297 48.5205 28.0107 45.629 28.0107C42.7374 28.0107 40.4185 30.3297 40.4185 33.2213C40.4185 34.449 50.8395 34.449 50.8395 33.2213Z",
    fill: "#344DF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.056 53.665C74.056 58.0712 71.4123 61.6233 68.1721 61.6233C64.9182 61.6233 62.2881 58.0712 62.2881 53.665H74.056Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8128 53.2134C53.8128 57.811 51.0542 61.7739 47.6733 61.7739C44.2781 61.7739 41.5337 57.811 41.5337 53.2134H53.8128Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3603 56.505C72.3603 57.7497 71.3454 58.7645 70.1009 58.7645C68.8562 58.7645 67.8413 57.7497 67.8413 56.505C67.8413 55.2413 68.8562 54.2456 70.1009 54.2456C71.3454 54.2456 72.3603 55.2413 72.3603 56.505Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.811 56.1769C51.811 57.4756 50.752 58.5345 49.4534 58.5345C48.1547 58.5345 47.0957 57.4756 47.0957 56.1769C47.0957 54.8583 48.1547 53.8193 49.4534 53.8193C50.752 53.8193 51.811 54.8583 51.811 56.1769Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6763 53.2656H74.9131V54.0656H61.6763V53.2656Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.561 52.813H54.3738V53.613H40.561V52.813Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8759 63.2264V62.4264H60.5759C59.6662 61.3245 58.6429 60.2352 57.7837 59.1209L58.4181 58.6318C59.4302 59.9436 60.7022 61.2588 61.7259 62.5818L62.2228 63.2264C61.8792 63.2264 57.6983 63.2264 57.8759 63.2264Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9213 68.9401L63.6807 68.1776C64.901 67.7901 65.9432 66.8058 66.3994 65.6089L67.1463 65.8933C66.5979 67.3339 65.3932 68.4729 63.9213 68.9401Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2212 76.1997L58.1431 75.4028C59.1399 75.3044 60.9274 74.9825 61.8931 74.7271L62.0962 75.5005C61.0806 75.7685 59.2696 76.095 58.2212 76.1997Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7422 77.1836L60.2158 77.0861L60.2686 77.8844L58.795 77.9819L58.7422 77.1836Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7446 77.9473L40.6665 77.1504C41.6634 77.052 43.4509 76.7301 44.4165 76.4746L44.6196 77.248C43.604 77.516 41.7931 77.8426 40.7446 77.9473Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3368 79.6885L41.2837 78.89L42.7571 78.7939L42.8103 79.5924L41.3368 79.6885Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2199 21.5544L53.5918 21.0575C54.6559 19.7138 55.5746 18.256 56.3199 16.7231L57.0387 17.0731C56.2684 18.6575 55.3199 20.1653 54.2199 21.5544Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1414 21.5037L33.7695 17.9514L34.3508 17.4014L37.7227 20.9537L37.1414 21.5037Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.b14a2ab6250603c938a96f405b567e8d.svg";
export { ForwardRef as ReactComponent };